import { useState } from 'react'
import styled, { css } from 'styled-components'
import Container, { ShiftAlign } from './layout/Container'
import SectionIntro from './SectionIntro'
import PlusIcon from './icons/PlusIcon'

function Faqs( { faqs } ) {
  return (
    <Container>
      <ShiftAlign>
        <SectionIntro>
          <h2>{ faqs.sectionTitle }</h2>
          <div 
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={ { __html: faqs.introCopy } } 
          />
          <StyledQuestions className="hod-grid-2-3">
            { faqs.faqs.map( faq => (
              <AccordianItem
                key={ faq.id }
                title={ faq.question }
                body={ faq.answer }
              />
            ) ) }
          </StyledQuestions>
        </SectionIntro>
      </ShiftAlign>
    </Container>
  )
}

function AccordianItem( { title, body, initiallyOpen = false } ) {
  const [isOpen, setIsOpen] = useState( initiallyOpen )

  return (
    <StyledAccordianItem $isOpen={ isOpen }>
      <button
        type="button"
        onClick={ () => setIsOpen( s => !s ) }
      >
        <h3>
          { title }
          <span>
            <PlusIcon />
          </span>
        </h3>
      </button>
      <div 
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={ { __html: body } } 
      />
    </StyledAccordianItem>
  )
}

const StyledQuestions = styled.div`
  padding-top: 2rem;
`

const StyledAccordianItem = styled.div<{ $isOpen: boolean }>`
  border-top: 1px solid ${ p => p.theme.colors.grey1 };

  button {
    width: 100%;
    padding: 0;
    border: 0;
    background: transparent;
    margin-left: auto;
    cursor: pointer;

    > h3 {
      display: flex;
      margin-bottom: 1rem;
      text-align: left;
      transition: color .3s ease-out;

      span {
        display: block;
        margin-left: auto;
        padding-left: 2rem;
      }

      svg {
        transform-origin: 50% 50%;
        transition: transform .3s ease-out;

        ${ p => p.$isOpen && css`
          transform: rotate( 45deg );
        ` }
      }
    }

    &:hover {
      > h3 {
        color: ${ p => p.theme.colors.highlight };
      }
    }
  }

  > div {
    overflow: hidden;
    height: 0;

    > *:last-child {
      margin-bottom: 1rem;
    }

    ${ p => p.$isOpen && css`
      height: auto;
    ` }
  }
`

export default Faqs
